'use strict';

import {BaseElement} from "../../../../../interfaces/BaseElement";
import Swiper from "swiper";
import {ApartmentCard} from "./ApartmentCard";
import {Buildings, components, isDesktop, isMobile, projectMode, settingsData} from "../../../../../../settings";
import {changeSelectionBoxesStatusColor, markSelectedApartments} from "../../../search";
import {EventBus} from "../../../../../interfaces/EventBus";
import {Amenities} from "../../../../../components/Amenities/Amenities";
import {
    findSelectionAndCrmData,
    moveAroundTheFloors,
    rotation_to_flat, setCSSVar,
    userPrevent, zoomOut,
    zoomToApartment,
} from '../../../../../../functions';
import {hoverOutPreviousSelection} from "../../../../../threejs/raycast";
import {renderUpdateValuesOnDemand} from '../../../../../../app';
import {openOptionsCard} from "../../../../../cards/optionsCards";
import {getCurrentLangDirection} from "../../../../../components/langSwitcher/langSwitcher";
import { ViewMode } from '../../../../../../common';
import {SwipeScript} from "../../../../../controls/swipe";
import {zoom} from "../../../../../../libs/directive";
import {IntersectionLegenda} from "../../../../../components/IntersectionLegenda";

export class ResultsViewer {
    #rootElement;
    #contentToShow;
    #viewerElement;
    #contentWrapper;
    #activeSlideElement;
    #isInitialToggle;
    #isThrottled;
    #searchStateSafe = [];

    constructor() {
        this.#isInitialToggle = true;
        this.#isThrottled = false;

        settingsData.searchResult = settingsData.allCrmData.filter(item => item.status === 'Available');

        this.#rootElement = new BaseElement()
            .addClass('mobile-search__results-viewer');

        this.#createViewerElement();
        // this.#addFontCheckerForIPhones();
        const selectionBoxColor = config.resources.bundle?.selectionBoxes?.colorStatus.find(color => color.status === 'available')?.active;
        setCSSVar('--selection-box-available-active', `${selectionBoxColor ? '#' + selectionBoxColor : '#0d84f2'}`);

        EventBus.add('resultsViewerToggleContent', this.#toggleContent.bind(this));
        EventBus.add('resultsViewerUpdateContent', this.#updateContent.bind(this));
        EventBus.add('resultsViewerSlideToApartment', this.#slideToApartment.bind(this));
        EventBus.add('resultsViewerScrollSlideIntoView', this.#scrollSlideIntoView.bind(this));
        EventBus.add('resultsViewerFilterCards', this.#filterApartmentCards.bind(this));
    }

    get rootElement() {
        return this.#rootElement;
    }

    remove() {
        EventBus.remove('resultsViewerToggleContent');
        EventBus.remove('resultsViewerUpdateContent');
        EventBus.remove('resultsViewerSlideToApartment');
        EventBus.remove('resultsViewerScrollSlideIntoView');
        EventBus.remove('resultsViewerFilterCards');

        this.#rootElement.remove();
        this.#rootElement = null;
    }

    #throttle() {
        this.#isThrottled = true;
        this.#contentWrapper.addStyle('pointer-events', 'none');
        setTimeout(() => {
            this.#isThrottled = false;
            this.#contentWrapper.addStyle('pointer-events', 'auto');
        }, 500);
    }

    #filterApartmentCards(activeBuildingId) {
        if (activeBuildingId) {
            this.#searchStateSafe = [...settingsData.searchResult];
            settingsData.searchResult = settingsData.searchResult.filter(item => item.buildingEngineId === activeBuildingId);
        } else {
            settingsData.searchResult = [...this.#searchStateSafe]
            this.#searchStateSafe = [];
        }

        this.#toggleContent();
    }

    #slideToApartment(id) {
        if (!id) {
            if (settingsData.buildingDestroyed) {
                id = settingsData.lastClickedFlat.name;
            } else {
                const lastClickedFlatBuildingName = settingsData.lastClickedFlat && settingsData.lastClickedFlat.userData.crm_data.buildingEngineId;
                const isLastClickedFlatFromCurrentBuilding = Boolean(Buildings.getActiveBuilding().name === lastClickedFlatBuildingName);
                const isLastClickedFlatInCarousel = Boolean(this.#rootElement.DOMElement.querySelector(`[data-engineid=${settingsData.lastClickedFlat.name}]`));
                id = isLastClickedFlatInCarousel && isLastClickedFlatFromCurrentBuilding
                    ? id = settingsData.lastClickedFlat.name
                    : components.mobileSearch.getApartmentId();
            }
        }


        if (!id)
            return;

        const targetElement = this.#rootElement.DOMElement.querySelector(`[data-engineId=${id}]`)?.parentElement;
        if (!targetElement)
            return;

        this.#scrollSlideIntoView(targetElement);

        const state = this.#isInitialToggle ? 'hidden' : 'focused'
        this.#rootElement.DOMElement
            .closest('.mobile-search__bottom-element')
            .setAttribute('data-state', state);

        if (state === 'focused') {
            IntersectionLegenda.hide();
            EventBus.trigger('buildingSwitcherHide');
        }
    }

    #createViewerElement() {
        let startX = 0;
        let preventTouchMove = false;
        let firstTouchMove = true;

        this.#viewerElement = new BaseElement()
            .addClass('mobile-search__viewer')
            .appendTo(this.#rootElement.DOMElement);
        this.#contentWrapper = new BaseElement()
            .addClass('mobile-search__content-wrapper')
            .event('click', this.#handleClick.bind(this))
            .event('scroll', (event) => {
                if (!this.#rootElement)
                    return;

                const state = this.#rootElement.DOMElement.closest('.mobile-search__bottom-element').getAttribute('data-state')
                if (state !== 'opened-fully' && !event.target.closest('.apartment-card__info-points') || this.#isThrottled)
                    event.preventDefault();
            })
            .event('touchstart', (event) => {
                startX = event.touches[0].clientX;
            })
            .event('touchend', () => {
                preventTouchMove = false;
                firstTouchMove = true;
            })
            .event('touchmove', (event) => {
                if (!this.#rootElement)
                    return;

                const state = this.#rootElement.DOMElement.closest('.mobile-search__bottom-element').getAttribute('data-state')
                const infoPoints = event.target.closest('.apartment-card__info-points');
                // if (infoPoints) event.stopPropagation();  // doesnt work
                if (infoPoints && firstTouchMove && event.touches[0].clientX != startX) {
                    const atLeft = infoPoints.scrollLeft == 0;
                    const atRight = infoPoints.scrollLeft + infoPoints.clientWidth >= infoPoints.scrollWidth;
                    if ((atLeft && event.touches[0].clientX > startX) || (atRight && event.touches[0].clientX < startX)) {
                        preventTouchMove = true;
                    }
                    firstTouchMove = false;
                }
                if (preventTouchMove) event.preventDefault();
                if (state !== 'opened-fully' && !infoPoints || this.#isThrottled)
                    event.preventDefault();
            })
            .appendTo(this.#viewerElement.DOMElement);

        this.#addSwipeListener();
        this.#addFocusOnSwipeLogic();
    }

    #addSwipeListener() {
        let startX = 0;
        let startY = 0;
        let endX = 0;
        let endY = 0;

        const element = this.#contentWrapper.DOMElement;

        element.addEventListener('touchstart', (e) => {
            if (userPrevent() || (settingsData.buildingDestroyed &&
                (this.#isThrottled || projectMode.FloorPlan.floorSlider.isScrolling || projectMode.FloorPlan.floorSlider.blockFloorSLider ))
            )
                return;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        });

        element.addEventListener('touchend', (e) => {
            if (userPrevent() || (settingsData.buildingDestroyed &&
                (this.#isThrottled || projectMode.FloorPlan.floorSlider.isScrolling || projectMode.FloorPlan.floorSlider.blockFloorSLider ))
            )
                return;
            endX = e.changedTouches[0].clientX;
            endY = e.changedTouches[0].clientY;

            const diffX = endX - startX;
            const diffY = endY - startY;

            if (Math.abs(diffX) > Math.abs(diffY)) {
                if (diffX > 30) {
                    this.#swipeRightHandler(e);
                } else if (diffX < -30) {
                    this.#swipeLeftHandler(e)
                }
            } /*else {
                if (diffY > 30) {
                    this.#swipeDownHandler();
                } else if (diffY < -30) {
                    this.#swipeUpHandler();
                }
            }*/
        });
    }

    #swipeRightHandler(event) {
        const state = this.#rootElement.DOMElement.parentElement.getAttribute('data-state');
        if (this.#isThrottled || state === 'opened-fully' || !this.#activeSlideElement || event.target.closest('.apartment-card__info-points'))
            return;

        const targetElement = getCurrentLangDirection() === 'ltr' ? this.#activeSlideElement.previousElementSibling : this.#activeSlideElement.nextElementSibling;
        if (!targetElement || targetElement.classList.contains('plug-slide') || targetElement.classList.contains('hidden'))
            return;

        this.#throttle();
        this.#scrollSlideIntoView(targetElement);
    }

    #swipeLeftHandler(event) {
        const state = this.#rootElement.DOMElement.parentElement.getAttribute('data-state');
        if (this.#isThrottled || state === 'opened-fully' || event.target.closest('.apartment-card__info-points'))
            return;

        const targetElement = getCurrentLangDirection() === 'ltr' ? this.#activeSlideElement.nextElementSibling : this.#activeSlideElement.previousElementSibling;
        if (!targetElement || targetElement.classList.contains('plug-slide') || targetElement.classList.contains('hidden'))
            return;

        this.#throttle();
        this.#scrollSlideIntoView(targetElement);
    }

    async #scrollSlideIntoView(targetElement) {
        if (this.#contentWrapper.DOMElement.children.length < 2) {
            if (targetElement) {
                this.#activeSlideElement = targetElement;
                this.#activeSlideElement.classList.add('active-slide');

                const activeCardApartmentEngineId = targetElement
                    .querySelector('.results-viewer__apartment-card')
                    .getAttribute('data-engineid');
                const {activeTower, selectedMesh} = findSelectionAndCrmData(activeCardApartmentEngineId);

                if (Buildings.activeBuilding.name !== activeTower.name &&
                    !projectMode.LiteMode.modeIs('picture') && !projectMode.LiteMode.modeIs('empty')) {
                    await projectMode.Cylinder.switchBuilding(activeTower.name, activeCardApartmentEngineId);
                    EventBus.trigger('buildingSwitcherSetActiveBuildingName');
                }

                !projectMode.LiteMode.modeIs('picture') && rotation_to_flat(selectedMesh, true);

                if (!config.features?.privateHouseMode) {
                    markSelectedApartments(activeCardApartmentEngineId);
                } else {
                    projectMode.Cylinder.cylinderBuildingLabels.markLabel(selectedMesh.userData.crm_data.buildingEngineId, 'click');
                }

                settingsData.lastClickedFlat = selectedMesh;

                if (!projectMode.LiteMode.modeIs('picture')) {
                    settingsData.activeModeSwitching = false;
                }
            }

            return;
        }

        if (this.#contentWrapper.DOMElement.children.length === 2) {
            const plugElement = targetElement ? targetElement.cloneNode() : this.#activeSlideElement.cloneNode();
            plugElement.classList.add('plug-slide');
            new BaseElement()
                .addClass('plug-slide__content')
                .appendTo(plugElement);
            this.#contentWrapper.DOMElement.append(plugElement);
        }

        if (!targetElement && this.#activeSlideElement) {
            this.#activeSlideElement.scrollIntoView({behavior: "instant", inline: "center"});
            return;
        }

        if (targetElement.parentElement.firstElementChild === targetElement) {
            targetElement.parentElement.prepend(targetElement.parentElement.lastElementChild);
        } else if (targetElement.parentElement.lastElementChild === targetElement) {
            targetElement.parentElement.append(targetElement.parentElement.firstElementChild);
        }

        const targetEngineId = targetElement && targetElement.querySelector('.results-viewer__apartment-card')?.getAttribute('data-engineid');
        const activeEngineId = this.#activeSlideElement && this.#activeSlideElement.querySelector('.results-viewer__apartment-card')?.getAttribute('data-engineid');
        const isSameElement = targetEngineId === activeEngineId;

        if (this.#activeSlideElement) {
            if (targetElement !== this.#activeSlideElement.nextElementSibling && targetElement !== this.#activeSlideElement.previousElementSibling) {
                targetElement.previousElementSibling.scrollIntoView({behavior: "instant", inline: "center"});
            } else {
                this.#activeSlideElement.scrollIntoView({behavior: "instant", inline: "center"});
            }
            this.#activeSlideElement.classList.remove('active-slide');
        }

        const behavior = isSameElement ? 'instant' : 'smooth';
        this.#activeSlideElement = targetElement;
        if (this.#activeSlideElement.classList.contains('plug-slide'))
            this.#activeSlideElement = this.#activeSlideElement.nextElementSibling;
        if (isSameElement && settingsData.activeModeSwitching && !config.features?.privateHouseMode)
            this.#activeSlideElement.querySelector('.results-viewer__apartment-card').style.transition = 'none';
        this.#activeSlideElement.classList.add('active-slide');
        this.#activeSlideElement.scrollIntoView({behavior, inline: "center"});
        if (isSameElement && settingsData.activeModeSwitching && !config.features?.privateHouseMode)
            this.#activeSlideElement.querySelector('.results-viewer__apartment-card').style.removeProperty('transition');
    }

    // #addFontCheckerForIPhones() {
    //     const testElement = new BaseElement()
    //         .setAttributes({
    //             'id': 'fontTestElement'
    //         })
    //         .addStyle('position', 'absolute')
    //         .addStyle('visibility', 'hidden')
    //         .addStyle('font-size', '16px')
    //         .innerHtml('FontTest')
    //         .appendTo(this.#rootElement.DOMElement);
    //
    //     let isInitialCheck = true;
    //     let lastFontSize = testElement.DOMElement.offsetHeight;
    //     function checkFontSize() {
    //         if (isInitialCheck) {
    //             isInitialCheck = false;
    //             return;
    //         }
    //
    //         const currentFontSize = testElement.DOMElement.offsetHeight;
    //         if (currentFontSize !== lastFontSize) {
    //             lastFontSize = currentFontSize;
    //
    //             EventBus.trigger('resultsViewerUpdateContent');
    //         }
    //     }
    //
    //     setInterval(checkFontSize, 500);
    // }

    #toggleContent() {
        this.#prepareApartments();
        this.#updateContent();
        this.#initialToggle();
    }

    #initialToggle() {
        if (!config.features?.privateHouseMode || config.features?.privateHouseMode && this.#isInitialToggle) {
            const activeCard = this.#contentWrapper.DOMElement.querySelector('.active-slide .results-viewer__apartment-card');
            const activeCardApartmentEngineId = activeCard ? activeCard.getAttribute('data-engineid') : null;
            if (activeCardApartmentEngineId) {
                if (!config.features?.privateHouseMode) {
                    if (this.#isInitialToggle)
                        userPrevent(false);
                    markSelectedApartments(activeCardApartmentEngineId);
                }

                const {selectedMesh} = findSelectionAndCrmData(activeCardApartmentEngineId);
                if (!projectMode.LiteMode.modeIs('picture') && !projectMode.LiteMode.modeIs('empty')) {
                    if (config.features?.privateHouseMode)
                        projectMode.Cylinder.cylinderBuildingLabels.markLabel(selectedMesh.userData.crm_data.buildingEngineId, 'click');
                    if (this.#isInitialToggle) {
                        rotation_to_flat(selectedMesh, true);
                        // zoomOut();
                    } else {
                        zoomToApartment(selectedMesh);
                    }
                }

                settingsData.lastClickedFlat = selectedMesh;
            }

            this.#isInitialToggle = false;
        }
    }

    #updateContent() {
        this.#refreshContentToShow();
        this.#slideToApartment();
    }

    #refreshContentToShow() {
        this.#contentWrapper.innerHtml('');

        this.#contentToShow.forEach((item) => {
            const container = new BaseElement()
                .addClass('mobile-search__item-container')
                .appendTo(this.#contentWrapper.DOMElement);

            new BaseElement(item).appendTo(container.DOMElement);
            EventBus.trigger('mobileSearchResultsAmountUpdate');
        });
    }

    #prepareApartments() {
        const isMoreThanOneBuildingInResults = settingsData.searchResult.some(item => item.buildingEngineId !== settingsData.searchResult[0].buildingEngineId);
        if (isMoreThanOneBuildingInResults) {
            EventBus.trigger('buildingSwitcherSetArrowsVisibilityTo', 'visible');
        } else {
            EventBus.trigger('buildingSwitcherSetArrowsVisibilityTo', 'hidden');
        }
        const sortByPrice = () => {
            // const separatedByBuildings = Object.groupBy(settingsData.searchResult, item => item.buildingEngineId);
            const separatedByBuildings = {};
            settingsData.searchResult.forEach(item => {
                if (!separatedByBuildings[item.buildingEngineId]) {
                    separatedByBuildings[item.buildingEngineId] = [item];
                } else {
                    separatedByBuildings[item.buildingEngineId].push(item);
                }
            });
            settingsData.searchResult = [];
            for (const buildingGroup in separatedByBuildings) {
                const currentBuildingResults = separatedByBuildings[buildingGroup];
                currentBuildingResults.sort((a, b) => a.salePrice - b.salePrice);
                settingsData.searchResult = settingsData.searchResult.concat(currentBuildingResults);
            }
        }
        const sortByAptNumber = () => {
            settingsData.searchResult.sort((a, b) => a.buildingEngineId.localeCompare(b.buildingEngineId));
        }

        changeSelectionBoxesStatusColor(settingsData.searchResult);
        this.#contentToShow = [];
        const isPricePresent = settingsData.searchResult.some(item => item.salePrice > 0);
        if (isPricePresent) {
            sortByPrice();
        } else {
            sortByAptNumber();
        }

        settingsData.searchResult.forEach((apartment) => {
            const apartmentCard = new ApartmentCard(apartment).rootElement;
            apartmentCard.addClass('results-viewer__card');
            this.#contentToShow.push(apartmentCard.DOMElement);
        });
    }

    #handleClick(event) {
        const bottomElementState = event.target.closest('.mobile-search__bottom-element').getAttribute('data-state');
        if (bottomElementState !== 'focused' && bottomElementState !== 'opened-fully')
            return;
        const isFavoriteButton = event.target.closest('.card__favorite-checkbox') || event.target.classList.contains('card__favorite-checkbox');
        const isKeyPlanButton = event.target.closest('.key-plan-button');
        if (isKeyPlanButton || isFavoriteButton) {
            return;
        }

        const targetItemContainer = event.target.closest('.mobile-search__item-container:not(.active-slide)');
        if (targetItemContainer && bottomElementState !== 'opened-fully') {
            if (targetItemContainer.nextElementSibling === this.#activeSlideElement) {
                getCurrentLangDirection() === 'ltr'
                    ? this.#swipeRightHandler(event)
                    : this.#swipeLeftHandler(event);
            } else if (targetItemContainer.previousElementSibling === this.#activeSlideElement) {
                getCurrentLangDirection() === 'ltr'
                    ? this.#swipeLeftHandler(event)
                    : this.#swipeRightHandler(event);
            }

            // return;
        }

        const apartmentCard = event.target.closest('.results-viewer__apartment-card');
        if (!apartmentCard)
            return;

        const apartmentEngineId = apartmentCard.getAttribute('data-engineid');
        if (!apartmentEngineId)
            return;

        if (bottomElementState !== 'opened-fully')
            return;

        const {crmDataOfFlat, selectedMesh} = findSelectionAndCrmData(apartmentEngineId);
        settingsData.lastClickedFlat = selectedMesh;
        openOptionsCard({object: crmDataOfFlat});
    }

    #addFocusOnSwipeLogic() {
        let touchEvent = false;
        let trigger = false;
        this.#contentWrapper.event('touchstart', () => {
            touchEvent = true;
            trigger = false;
        });

        this.#contentWrapper.event('transitionend', async () => {
            if (!this.#contentWrapper || trigger)
                return;

            trigger = true;
            const activeCard = this.#contentWrapper.DOMElement.querySelector('.active-slide .results-viewer__apartment-card');
            const activeCardApartmentEngineId = activeCard ? activeCard.getAttribute('data-engineid') : null;
            if (!activeCardApartmentEngineId)
                return;

            if (!projectMode.LiteMode.modeIs('picture'))
                settingsData.activeModeSwitching = true;

            const {activeTower, selectedMesh} = findSelectionAndCrmData(activeCardApartmentEngineId);
            if (config.features?.privateHouseMode && selectedMesh.userData.crm_data.buildingEngineId !== Buildings.getActiveBuilding().name) {
                projectMode.Cylinder.cylinderBuildingLabels.markLabel(Buildings.getActiveBuilding().name, 'close');
            }

            if (Buildings.activeBuilding.name !== activeTower.name &&
                !projectMode.LiteMode.modeIs('picture') && !projectMode.LiteMode.modeIs('empty')) {
                await projectMode.Cylinder.switchBuilding(activeTower.name, activeCardApartmentEngineId);
                EventBus.trigger('buildingSwitcherSetActiveBuildingName');
            }

            renderUpdateValuesOnDemand(false);
            if (touchEvent) {
                const state = this.#rootElement.DOMElement.parentElement.getAttribute('data-state');
                if (settingsData.buildingDestroyed) {
                    await moveAroundTheFloors(selectedMesh.userData.crm_data.engineId);
                } else if (state === 'focused' && settingsData.activeViewMode === ViewMode.Cylinder) {
                    zoomToApartment(selectedMesh);
                } else {
                    !projectMode.LiteMode.modeIs('picture') && rotation_to_flat(selectedMesh, true);
                }
            }
            if (!config.features?.privateHouseMode) {
                markSelectedApartments(activeCardApartmentEngineId);
            } else {
                projectMode.Cylinder.cylinderBuildingLabels.markLabel(selectedMesh.userData.crm_data.buildingEngineId, 'click');
            }
            settingsData.lastClickedFlat = selectedMesh;

            if (!projectMode.LiteMode.modeIs('picture')) {
                settingsData.activeModeSwitching = false;
            }

            touchEvent = false;
            trigger = false
        });
    }
}
